function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/* eslint-disable-next-line */
__webpack_public_path__ = '/static/js/onlinecourseunit/';
import Video from 'integration-web-core--socle/js/assets/modules/_video.class';
import LinkedContent from '../common/_linked-content';
import Accordion from '@mozaic-ds/freemarker/js/modules/_accordion.js';
import Workshop from './includes/Workshop';
import Modal from '@mozaic-ds/freemarker/js/modules/_modal';
import Carousel from '@mozaic-ds/freemarker/js/modules/_carousel.js';
var OnlineCourseUnit = /*#__PURE__*/function (_lm$Composant) {
  /**
   * @constructor
   * @param {String} id
   */
  function OnlineCourseUnit(id) {
    var _this;
    _classCallCheck(this, OnlineCourseUnit);
    _this = _callSuper(this, OnlineCourseUnit, [id]);
    _this.linkedContent = new LinkedContent(_this.target);
    _this.workshop = new Workshop(_this);
    _toConsumableArray(document.querySelectorAll('.o-step__image--picture')).forEach(function (image, i) {
      image.addEventListener('click', function () {
        _this.popin = new Modal({
          classContent: "js-image-".concat(i)
        });
        _this.popin.open();
      });
    });

    // Video
    if (document.querySelector('.video-js')) {
      new Video();
    }

    // Jsonld
    window.addEventListener('DOMContentLoaded', function () {
      var jsonldData = JSON.parse(document.querySelector('#component-onlinecourseunit script.dataJsonLd').innerHTML);
      if (jsonldData) {
        window.MetaTagEventBus.emit('jsonLdTrigger', {
          data: jsonldData
        });
      }
    });

    // Accordion steps
    _toConsumableArray(_this.target.querySelectorAll('.js-accordion')).forEach(function (el) {
      new Accordion(el);
    });
    _toConsumableArray(document.querySelectorAll('.o-tools__tab')).forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelector('.o-tools__tab--active').classList.remove('o-tools__tab--active');
        e.target.classList.add('o-tools__tab--active');
      });
    });
    document.querySelectorAll('.js-show-more-products').forEach(function (button) {
      button.addEventListener('click', function () {
        var targetElement = document.getElementById('linked-products');
        if (targetElement) {
          var offset = -100;
          var elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top: elementPosition + offset,
            behavior: 'smooth'
          });
        }
      });
    });

    // Tools modal in mobile
    var toolsModalButton = document.querySelector('.js-open-tools-modal');
    if (toolsModalButton != null) {
      toolsModalButton.addEventListener('click', function () {
        _this.popin = new Modal({
          classContent: 'js-modal-tools'
        });
        console.log();
        _this.popin.open();
      });
    }
    _toConsumableArray(document.querySelectorAll('.o-linked-products__slider')).forEach(function (slider) {
      var carouselElement = document.getElementById(slider.id);
      var carouselItems = carouselElement.querySelectorAll('.js-carousel-item-list > li');
      if (carouselItems.length !== 0) {
        new Carousel(carouselElement, {
          centerWhenNoButtons: false
        });
      }
    });
    var tabs = document.querySelectorAll('.o-tools__tab');
    var tabPanels = document.querySelectorAll('.o-tools__tab-panel');

    // Initialization of ARIA attributes
    tabs.forEach(function (tab, index) {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('id', "tab-".concat(index));
      tab.setAttribute('aria-controls', "tabpanel-".concat(index));
      tab.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
      tab.setAttribute('tabindex', index === 0 ? '0' : '-1');
    });
    tabPanels.forEach(function (panel, index) {
      panel.setAttribute('role', 'tabpanel');
      if (!panel.hasAttribute('id')) {
        panel.setAttribute('id', "tabpanel-".concat(index));
      }
      panel.setAttribute('aria-labelledby', "tab-".concat(index));
      panel.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
      if (index === 0) {
        panel.classList.add('o-tools__tab-panel--active');
      }
    });

    // Management of tabs clicks
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activateTab(index);
      });
      tab.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') {
          var nextIndex = (index + 1) % tabs.length;
          activateTab(nextIndex);
          tabs[nextIndex].focus();
        } else if (e.key === 'ArrowLeft') {
          var prevIndex = (index - 1 + tabs.length) % tabs.length;
          activateTab(prevIndex);
          tabs[prevIndex].focus();
        }
      });
    });

    // Function to active a tab
    function activateTab(index) {
      tabs.forEach(function (tab, i) {
        var isSelected = i === index;
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.setAttribute('tabindex', isSelected ? '0' : '-1');
        tab.classList.toggle('o-tools__tab--active', isSelected);
      });
      tabPanels.forEach(function (panel, i) {
        var isVisible = i === index;
        panel.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
        panel.classList.toggle('o-tools__tab-panel--active', isVisible);
      });
    }
    return _this;
  }
  _inherits(OnlineCourseUnit, _lm$Composant);
  return _createClass(OnlineCourseUnit);
}(lm.Composant); // Add tag for Sentry
lm.sentry.configureScope(function (scope) {
  scope.setTag('kobi.composant', 'onlinecourseunit');
});
lm.DOMReady(function () {
  new OnlineCourseUnit('onlinecourseunit');
});